import React, { useState, useEffect } from "react"

import {
  FiAlertTriangle,
  FiAlertCircle,
  FiAlertOctagon,
  FiX,
} from "react-icons/fi"

import * as style from "./Alert.module.scss"

const Alert = ({ explorer }) => {
  const [closed, setClosed] = useState(false)

  const close = () => {
    setClosed(true)
  }

  useEffect(() => {
    setClosed(!explorer.alert || explorer.alert.message === null)
  }, [explorer.alert])

  return (
    <>
      {explorer && explorer.alert && !closed && (
        <div className={style.alert} data-type={explorer.alert.type}>
          {explorer.alert.type === "warning" && <FiAlertTriangle />}
          {explorer.alert.type === "info" && <FiAlertCircle />}
          {explorer.alert.type === "success" && <FiAlertCircle />}
          {explorer.alert.type === "error" && <FiAlertOctagon />}
          <span>{explorer.alert.message}</span>
          <button onClick={close}>
            <FiX />
          </button>
        </div>
      )}
    </>
  )
}

export default Alert
